import ShippingAction from "../../../../view/action/order/ShippingAction";

export default {
    changeMapDispatch: {
        sortOrder: 1,
        disabled: false,
        after: (result, dispatch) => {
            return {
                ...result,
                setIsCreatingShipment:
                    isCreatingShipment  => dispatch(ShippingAction.setIsCreatingShipment(isCreatingShipment))
            }
        }
    },
}


// WEBPACK FOOTER //
// ./src/extension/take-shipment/plugin/view/container/order/OrderDetailContainerPlugin.js